module.exports = __webpack_public_path__ + "static/media/arrow-down.2ad26201.svg";